import { useRef } from 'react';
import { useNavigate as useRouterNavigate, } from 'react-router-dom';
import { ROUTES } from "../../routes";
import { SPARKFLOW_BASE_PATHS } from "../../utils/sparkflow-constants";
import { buildPathWithParams } from "../../utils/utils";
export function getSparkflowNavService(navigate) {
    return {
        goToUseCase: () => {
            navigate(`${SPARKFLOW_BASE_PATHS.ONBOARDING}/${ROUTES.UseCase.path}`);
        },
        goToSparkflowPinboard: (pinboardId, urlQueryParams) => {
            const path = buildPathWithParams(`${SPARKFLOW_BASE_PATHS.PINBOARD}/${pinboardId}`, urlQueryParams);
            navigate(path);
        },
        goToSpotbuildIntegration: () => {
            navigate(`${SPARKFLOW_BASE_PATHS.ONBOARDING}/${ROUTES.SpotbuildIntegration.path}`);
        },
        goToAgentSelection: () => {
            navigate(`${SPARKFLOW_BASE_PATHS.ONBOARDING}/${ROUTES.AgentSelection.path}`);
        },
        navigate,
    };
}
export function useSparkflowNavService() {
    const navigate = useRouterNavigate();
    const navService = useRef(null);
    if (!navService.current) {
        navService.current = getSparkflowNavService(navigate);
    }
    return navService.current;
}
//# sourceMappingURL=nav-service.js.map